import { useRef, useContext, useState, useEffect } from 'react';

import styles from './PreviewImageFileComponent.module.css'

import { GlobalContext } from '../../../contexts/globalContext';

import CustomMultitouchComponent from '../../../files/CustomMultitouchComponent';

import { GetMaxZIndex } from '../../../utils/UtilitaryFunctions';


const PreviewImageFileComponent = ({ file, setTopicFilesOpened }) => {
    const { appWidth, appHeight, setAlertMessage } = useContext(GlobalContext);

    const ref = useRef(null);
    const imgRef = useRef(null);
    const mtRef = useRef(null);
    const isOpenCanvasRef = useRef(false);

    const [isVisible, setIsVisible] = useState(false);

    const startingHeight = 600;

    const options = {
        appWidth,
        appHeight,
        maxScale: appHeight / startingHeight,
        minScale: 0.5
    }

    const calculateWidth = () => {
        if (imgRef.current) {
            const containerHeight = startingHeight;
            const image = imgRef.current;
            const imageAspectRatio = image.height / image.width;
            const containerWidth = containerHeight / imageAspectRatio;

            return containerWidth;
        }

        return 0;
    };

    const containerStyle = {
        width: `${isVisible ? calculateWidth() : 60}px`,
        height: `${isVisible ? startingHeight : 75}px`,
        backdropFilter: `${isVisible ? 'blur(10px)' : ''}`,
        backgroundColor: `${isVisible ? 'rgba(0, 0, 0, 0.3)' : 'transparent'}`
    };


    useEffect(() => {
        mtRef.current.style.zIndex = GetMaxZIndex() + 1;
    }, [])


    const onMinScaleReached = () => {
        setTopicFilesOpened(files => files.filter(a => a.uid !== file.uid));
    }


    return (
        <CustomMultitouchComponent ref={mtRef} dragGesture={false} x={file.x + 75} y={file.y + 40} onMinScaleReached={onMinScaleReached} options={options} 
            dragGestureMouse={true} dragBox={{ x: 0, y: 0, width: appWidth, height: appHeight }} isOpenCanvasRef={isOpenCanvasRef}>
            <div className={styles.touch_component} ref={ref} style={containerStyle} dragGestureMouse={true} dragBox={{ x: 0, y: 0, width: appWidth, height: appHeight }}>
                <img alt="imagine" ref={imgRef} style={{ borderRadius: "0px", width: "100%" }} onLoad={() => { setIsVisible(true) }} draggable="false"
                    src={process.env.REACT_APP_CMS_URL + file.path} onError={() => {
                    setAlertMessage({ type: "ERROR", message: "The file is no longer at the address provided." })
                    onMinScaleReached()
                }}/>
            </div>
        </CustomMultitouchComponent>
    );

}

export default PreviewImageFileComponent;